let intialState = {
    months: [],
    scores: [],
    engagement_score: '',
    subject: [],
    subjectContent: [],
    contentCounts: [],
    consumed: []
}

export default function dashboardReducer(state = intialState, action) {
    let stateCopy = JSON.parse(JSON.stringify(state))
    switch (action.type) {
        case "Get_Engagement_Score":
            stateCopy.months = action.payload.months;
            stateCopy.scores = action.payload.scores;
            stateCopy.engagement_score = action.payload.engagement_score;
            return stateCopy;
        case "Get_Count_Subject":
            stateCopy.subjectContent = action.payload.data || [];
            stateCopy.subject = stateCopy.subjectContent.map(item => item.title);
            stateCopy.contentCounts = [
                { name: "Article", data: stateCopy.subjectContent.map(item => item.article) },
                { name: "Video", data: stateCopy.subjectContent.map(item => item.video) },
                { name: "Quiz", data: stateCopy.subjectContent.map(item => item.quiz) },
                { name: "Document", data: stateCopy.subjectContent.map(item => item.document) }
            ];
            return stateCopy;
        case "Get_Monthly":
            stateCopy.months1 = action.payload.months;
            stateCopy.consumed = action.payload.data;
            return stateCopy;
        case 'Get_Topic_Matrics':
            stateCopy.topicMatrics = action.payload;
            return stateCopy;
        case 'Get_Subject_Metrics':
            stateCopy.subjectMetrics = action.payload.data;
            return stateCopy;
        default:
            return stateCopy;
    }
}